<template>
    <UserPageLayout>
        <div v-if="isValidToken" style="margin-bottom: 4rem;">
            <h1 class="text-white text-center text-3xl">Reset Password</h1>
        </div>

        <div v-if="isValidToken" class="max-w-lg mx-auto">
            <form @submit.prevent="resetPassword()" action="">
                <div class="form-group mb-3">
                    <label class="input-label text-center" for="name">New Password</label>
                    <input
                        name="new_password"
                        data-vv-as="new password"
                        v-validate="{'required': true, 'min': 6}"
                        v-model="form.new_password"
                        class="input input-block input-text-center"
                        ref="new_password"
                        type="password">
                    <span v-if="errors.has('new_password')" class="has-error text-center">{{ errors.first('new_password') }}</span>
                </div>
                <div class="form-group mb-3">
                    <label class="input-label text-center" for="name">Confirm New Password</label>
                    <input
                        name="new_password_confirm"
                        data-vv-as="new password confirmation"
                        v-validate="{'required': true, 'confirmed': 'new_password', 'min': 6}"
                        v-model="form.new_password_confirm"
                        class="input input-block input-text-center"
                        type="password">
                    <span v-if="errors.has('new_password_confirm')" class="has-error text-center">{{ errors.first('new_password_confirm') }}</span>
                </div>

                <div class="flex items-center flex-col justify-center w-full h-full mt-6">
                    <button class="btn text-lg btn-large block mb-1 uppercase font-opensans">Reset Password</button>
                </div>
            </form>
        </div>
    </UserPageLayout>
</template>

<script>

import UserPageLayout from '@/layouts/UserPage'
import appConfig from '@/app.config.js'
import AuthPopupMixin from '@/mixins/auth-popup'
import Request from '@/lib/request.js'
import popup from '@/lib/popup.js'

export default {
    name: 'ResetPassword',

    mixins: [AuthPopupMixin],

    components: {
        UserPageLayout
    },

    data () {
        return {
            isValidToken: false,
            form: {
                new_password: '',
                new_password_confirm: ''
            }
        }
    },

    mounted () {
        this.validateToken()
    },

    methods: {

        validateToken () {
            const request = new Request
            const url = appConfig.api.validateResetPasswordToken.replace(/__token__/, this.$route.params.token)

            this.$store.commit('toggleMainLoader', true)

            request.get(url)
                .then(res => {
                    if (res) {
                        this.isValidToken = true
                        this.$store.commit('toggleMainLoader', false)
                    }
                })
                .catch(err => {
                    if (err) {
                        this.$store.commit('toggleMainLoader', false)
                        window.location.href = '/'
                    }
                })
        },

        resetPassword () {

            this.$validator.validate().then((result) => {

                if (!result) {
                    return
                }

                const request = new Request
                const url = appConfig.api.resetPassword.replace(/__token__/, this.$route.params.token)

                this.$store.commit('toggleMainLoader', true)

                request.post(url, this.form)
                    .then(res => {
                        if (res) {
                            this.$store.commit('toggleMainLoader', false)

                            popup.alert('Your password is reset', () => {
                                window.location.href = '/'
                            })
                        }
                    })
                    .catch(err => {
                        if (err) {
                            this.$store.commit('toggleMainLoader', false)

                            popup.alert('Reset password fail')
                        }
                    })
            })
        }
    }
}
</script>
